import * as React from 'react'
import type { SVGProps } from 'react'
export interface ChevronRightIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * chevron-right
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const ChevronRightIcon = (props: ChevronRightIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m9 6l6 6l-6 6"
      />
    </svg>
  )
}
